import { Drum, Globe2, Heart, Users } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, SectionHead } from "../components/Section";
import { NewsletterForm } from "../components/NewsletterForm";
import { IMAGES } from "../data/site";

export default function About() {
    const { t } = useLang();
    const VALUES = [
        { icon: Drum, title: t("v1t"), text: t("v1d") },
        { icon: Users, title: t("v2t"), text: t("v2d") },
        { icon: Globe2, title: t("v3t"), text: t("v3d") },
        { icon: Heart, title: t("v4t"), text: t("v4d") },
    ];

    return (
        <div data-testid="about-page" className="pt-32 pb-24">
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHead eyebrow={t("about_eyebrow")} title={t("about_title")} testId="about-title" />
                <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                    <Reveal>
                        <div className="rounded-3xl overflow-hidden border border-lakou-gold/20 aspect-[4/5]">
                            <img src={IMAGES.squad} alt="The LAKOU tribe" className="w-full h-full object-cover" />
                        </div>
                    </Reveal>
                    <Reveal delay={0.12} className="space-y-5 text-lakou-grey leading-relaxed">
                        <p>{t("about_p1")}</p>
                        <p>{t("about_p2")}</p>
                        <p>{t("about_p3")}</p>
                    </Reveal>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-28">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {VALUES.map((v, i) => (
                        <Reveal key={v.title} delay={i * 0.08}>
                            <div className="h-full rounded-3xl border border-lakou-gold/15 bg-lakou-coal/60 p-7 hover:border-lakou-gold/40 transition-colors duration-500">
                                <v.icon size={22} className="text-lakou-gold" />
                                <div className="mt-4 font-display font-bold text-lg text-lakou-cream">{v.title}</div>
                                <p className="mt-2 text-sm text-lakou-grey leading-relaxed">{v.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="max-w-3xl mx-auto px-4 sm:px-6 mt-28 text-center">
                <Reveal>
                    <h2 className="font-display font-extrabold text-3xl text-lakou-cream tracking-tight">{t("grow_title")}</h2>
                    <p className="mt-4 text-lakou-grey">{t("grow_sub")}</p>
                    <div className="mt-8"><NewsletterForm /></div>
                </Reveal>
            </section>
        </div>
    );
}
